import React, { useEffect } from "react";

const DTOGiveFeedbackModal = () => {
  return <></>;
};

export default DTOGiveFeedbackModal;
